export function ErrorText({ children }: React.PropsWithChildren) {
    return <div style={{ color: "red" }}>{children}</div>;
}
